import * as yup from 'yup';

import { makeValidateSync } from '@cast/utils';

import { isOverridden } from 'features/cluster/workload-optimization/_woop-settings/_validations/is-overridden';

import { hpaV2ValidationSchema } from './hpa-v2-validation.schema';
import { vpaValidationSchema } from './vpa-validation.schema';

// new HPA with hpaSettings wrapper
const rightsizingSettingsV2ValidationSchema = yup.object({
  horizontalRightsizing: isOverridden(
    yup.object({
      hpaSettings: yup.lazy((value) =>
        value !== undefined ? hpaV2ValidationSchema : yup.mixed().nullable()
      ),
    }),
    false
  ),
  verticalRightsizing: yup.object({
    policy: vpaValidationSchema,
  }),
});

export const validateRightsizingSettingsV2 = makeValidateSync(
  rightsizingSettingsV2ValidationSchema
);
